import React, {useState} from "react";
import {Button, Form, Modal} from "react-bootstrap";
import toast, {Toaster} from "react-hot-toast";

const ParseTextButton = ({text}) => {
  const [show, setShow] = useState(false);

  const copyText = () => {
    navigator.clipboard.writeText(text)
      .then(() => window.alert("Текст парса скопирован"))
      .catch(() => window.alert("Не удалось скопировать"));
  };

  return (
    <>
      <Toaster position="bottom-center" toastOptions={{duration: 1500}}/>
      <Button size="sm" variant="outline-primary" className="mt-2" onClick={() => setShow(true)}>
        Показать текст парса
      </Button>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Текст парса</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control as="textarea" rows="20" value={text} readOnly/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Закрыть
          </Button>
          <Button variant="primary" onClick={copyText}>
            Копировать
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ParseTextButton;
